import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import { BtnChiTiet } from "./ChucNang/ChiTiet/BtnChiTiet";
import { BtnSua } from "./ChucNang/Sua/BtnSua";
import { BtnKhoa } from "./ChucNang/Khoa/BtnKhoa";
import { BtnMoKhoa } from "./ChucNang/MoKhoa/BtnMoKhoa";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";

export const ContentTable = ({ listDanhSach }) => {
  const dataSearch = useSelector((state) => state.dataSearchCauHinhGoiTraGop);
  return listDanhSach.map((item, index) => (
    <div className="custom-table-row">
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center">
            {index + 1 + (dataSearch.iPageIndex - 1) * 20}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-40 flex-basis-40-sm">
        <span className="mobile-column-name">Tên sản phẩm</span>
        <div className="center-wrapper">
          <p className="text-left">
            <BtnChiTiet item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Số lượng gói</span>
        <div className="center-wrapper">
          <p className="text-center">{item.lstGoi.length}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-20 flex-basis-20-sml">
        <span className="mobile-column-name">Trạng thái</span>
        <div className="center-wrapper">
          <p className="text-center">
            {item.TrangThai === true ? "Đang sử dụng" : "Tạm khoá"}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-20 flex-basis-20-sm  action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            <BtnSua item={item} />
            {item.TrangThai === true ? (
              <BtnKhoa item={item} />
            ) : (
              <BtnMoKhoa item={item} />
            )}

            <BtnXoa item={item} />
          </div>
        </div>
      </div>
    </div>
  ));
};
